import React from "react";
import "../components/Nosotros.css";
import iconoPrimus1 from "../assets/img/iconoprimus1.gif";
import iconoPrimus2 from "../assets/img/iconoprimus2.gif";
import iconoPrimus3 from "../assets/img/iconoprimus3.gif";
import culturav2 from "../assets/img/culturav2.jpg";
import correct3 from "../assets/img/correct3.gif";
import valor1 from "../assets/img/valor1.gif";
import correct1 from "../assets/img/correct1.gif";
import valor3 from "../assets/img/valor3.gif";

import Footer from "../components/Footer";

const Nosotros = () => {
  return (
    <div className="divNosotros">
      <div className="bannerNosotros">
        <h1 className="bannerNosotros-title">Somos Primus Capital</h1>
      </div>
      <div className="containerBanner">
        <p className="textoBanner">
          Nacimos en 2014 con la experiencia de un grupo de ejecutivos y
          profesionales de alto nivel, alineados con el respaldo de un equipo
          directivo conformado por empresarios de importante renombre.
        </p>
      </div>
      <div className="divCuadros">
        <div className="containerCuadros">
          <div className="boxCuadros">
            <img src={iconoPrimus1} alt="Atención de Primera" />
            <p>Atención de Primera</p>
          </div>
          <div className="boxCuadros">
            <img src={iconoPrimus2} alt="Seguridad y Agilidad" />
            <p>Seguridad y Agilidad</p>
          </div>
          <div className="boxCuadros">
            <img src={iconoPrimus3} alt="Tecnología de Vanguardia" />
            <p>Tecnología de Vanguardia</p>
          </div>
        </div>
      </div>
      {/* cuadro adicional */}
      <div className="cuadro-adicionalNosotros">
        <img
          className="imagen-cuadroNosotros"
          src={culturav2}
          alt="Cultura Lápiz Primus"
        />
        <div className="divPlataformaNosotros">
          <div>
            <h2>Cultura que nos guía</h2>
          </div>

          <div className="divPlataformaTextoNosotros">
            <div>
              <h4>MISIÓN</h4>
            </div>
            <div>
              <span>
                "Ser un actor relevante en el mercado financiero, garantizando
                soluciones integrales que de forma oportuna aporten al éxito de
                nuestros clientes y de sus negocios, a través del respaldo de
                nuestra gestión afianzada en la excelencia, asesoría proactiva y
                ética profesional."
              </span>
            </div>
          </div>
          <div>
            <div>
              <h4>VISIÓN</h4>
            </div>
            <div>
              <span>
                "Ser la empresa líder del sector financiero a nivel local con
                amplio impacto en el mercado regional, reconocida por su cultura
                de trabajo centrada en el cliente y por la garantía de
                soluciones integrales eficientes, innovadoras, ágiles y
                transparentes."
              </span>
            </div>
          </div>
          <div>
            <div>
              <h4>PROPÓSITO</h4>
            </div>
            <div>
              <span>
                "Entregar servicios de factoring de excelencia, apoyando
                financieramente a nuestros clientes para asegurar la continuidad
                de sus negocios."
              </span>
            </div>
          </div>
        </div>
      </div>
      {/* Valores que nos identifican */}
      <div className="valores">
        <div className="containerValores">
          <h1 className="titleValores">Valores que nos identifican</h1>
          <div className="columnsValores">
            <div className="columnValores">
              <img src={correct1} alt="Gif 1" />
              <div className="column-titleValores">Agilidad</div>
              <div className="column-textValores">
                Conocemos las necesidades financieras de nuestros clientes, por
                eso, procuramos una rápida atención, apoyados en tecnología de
                vanguardia para cumplir en tiempo y forma todos los
                requerimientos.
              </div>
            </div>
            <div className="columnValores">
              <img src={correct3} alt="Gif 1" />
              <div className="column-titleValores">Excelencia</div>
              <div className="column-textValores">
                Contamos con un equipo integral compuesto por profesionales
                capaces de asesorar y resolver las necesidades de nuestros
                clientes.
              </div>
            </div>
            <div className="columnValores">
              <img src={valor1} alt="Gif 2" />
              <div className="column-titleValores">Integridad</div>
              <div className="column-textValores">
                Todos nuestros servicios se regulan por normas vigentes, siendo
                la transparencia y la ética empresarial uno de nuestros mayores
                sellos de calidad.
              </div>
            </div>
            <div className="columnValores">
              <img src={iconoPrimus3} alt="Gif 3" />
              <div className="column-titleValores">Innovación</div>
              <div className="column-textValores">
                Nos mantenemos en constante evolución acorde a los avances
                tecnológicos para garantizar la mejor atención de forma rápida,
                segura y oportuna.
              </div>
            </div>
            <div className="columnValores">
              <img src={valor3} alt="Gif 4" />
              <div className="column-titleValores">Eficiencia</div>
              <div className="column-textValores">
              Ofrecemos servicio y asesoría proactiva, adelantándonos a las necesidades de nuestros clientes.
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Equipo Primus Capital */}
      <div className="containerEquipo">
        <h1 className="titleEquipo">Equipo Primus Capital</h1>
        <div className="board-containerEquipo">
          <h2 className="board-titleEquipo">
            El Directorio de Primus Capital lo integra:
          </h2>
          <div className="columnsEquipo">
            <div className="columnEquipo">
              <div className="nameEquipo">Rafael Fernández</div>
              <div className="positionEquipo">Presidente</div>
              <div className="nameEquipo">Raimundo Valenzuela</div>
              <div className="positionEquipo">Director</div>
            </div>
            <div className="columnEquipo">
              <div className="nameEquipo">Eduardo Guerrero</div>
              <div className="positionEquipo">Director</div>
              <div className="nameEquipo">Benjamín Laso</div>
              <div className="positionEquipo">Director</div>
            </div>
            <div className="columnEquipo">
              <div className="nameEquipo">Alvaro Borgoño</div>
              <div className="positionEquipo">Director</div>
            </div>
          </div>
        </div>
        <div className="board-containerEquipoEjecutivos">
          <h2 className="board-titleEquipo">Principales Ejecutivos:</h2>
          <div className="columnsEquipo">
            <div className="columnEquipo">
              <div className="nameEquipo">Luis José Risco</div>
              <div className="positionEquipo">Gerente Comercial</div>
              <div className="nameEquipo">Carla Santibáñez</div>
              <div className="positionEquipo">
              Gerente de Operaciones
              </div>
            </div>
            <div className="columnEquipo">
              <div className="nameEquipo">Abraham Carpio</div>
              <div className="positionEquipo">Gerente de Riesgos</div>
              
            </div>            
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Nosotros;
